import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { LegendItem } from './legend-item.model';

@Component({
    selector: 'legend',
	encapsulation: ViewEncapsulation.None,
	templateUrl: 'legend.component.html'
})
export class LegendComponent {
    @Input() title = 'Legend';
    @Input() rows: Array<LegendItem> = [];
    @Input() interactive = false;
    @Input() colorLabels = false;
    @Input() highlight = false;
    @Input() cursor = 'pointer';
    @Input() standAloneLegend = false;
    @Input() isStackIcons = false;
    @Output() private change: EventEmitter<LegendItem> = new EventEmitter<LegendItem>();

    constructor() {}

    public onclick(event: Event, item: LegendItem) {
        if (this.interactive) {
            item.checked = !item.checked;
            this.change.emit(item);
        }
    }
}
